export const onSave = (rfInstance, flowKey = 'example-flow') => {
    if (rfInstance) {
      localStorage.setItem(flowKey, JSON.stringify(rfInstance));
      alert('Flow saved to localStorage.');
    }
  };
  